import React from "react"
import { Link } from "gatsby"

const SectionCta = () => (
  <section className="ctaband">
    <div className="wrap">
      <h2>See where your TEAM episodes stand</h2>
      <p>
        Our team will walk through where your TEAM episodes stand and where your
        largest opportunities are.
      </p>
      <div className="cta-row">
        <Link className="cta" to="/contact-us/">
          Speak with an Expert
        </Link>
      </div>
    </div>
  </section>
)

export default SectionCta
